import { DocumentItemOutput } from '@allocab/allocab-driver-service-types';

export type DocumentItemStatus = 'VALIDATED' | 'MODIFIED' | 'REJECTED' | 'TO_DEFINE';

export const isDocumentStatusComplete = (status: DocumentItemStatus) => status === 'VALIDATED' || status === 'MODIFIED';

export const isDocumentItemComplete = (documentItem: DocumentItemOutput) => {
  const documentStatus = getDocumentItemStatus(documentItem);

  return isDocumentStatusComplete(documentStatus);
};

export const getDocumentItemStatus = (documentItem: DocumentItemOutput): DocumentItemStatus => {
  const { doc } = documentItem;

  const rectoStatus = doc?.statusRecto ?? 'TO_DEFINE';
  const versoStatus = doc?.rectoVerso ? doc.statusVerso ?? 'TO_DEFINE' : 'VALIDATED';

  if (rectoStatus === 'VALIDATED' && versoStatus === 'VALIDATED') {
    return 'VALIDATED';
  }

  if (
    (rectoStatus === 'VALIDATED' || rectoStatus === 'MODIFIED') &&
    (versoStatus === 'VALIDATED' || versoStatus === 'MODIFIED')
  ) {
    return 'MODIFIED';
  }

  if (rectoStatus === 'REJECTED' || versoStatus === 'REJECTED') {
    return 'REJECTED';
  }

  return 'TO_DEFINE';
};
